module.exports = __webpack_public_path__ + "img/img_kv_txt4.aae84b59.png";